export const DISPLAY_SCALE = 0.12;
